import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-empty-container',
    templateUrl: './empty-container.component.html',
    styleUrls: ['./empty-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EmptyContainerComponent {
    @Input() containerGutter = 'gx-16';
    @Input() containerClasses = '';
}
